"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _context = require("../context");

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Container = (0, _context.styledWithTheme)('div', {
  // stylelint-disable-next-line
  shouldForwardProp: (0, _utils.filterProps)(['isDisabled'])
})(function (_ref) {
  var selectors = _ref.theme.selectors,
      isDisabled = _ref.isDisabled;
  var hoverLabelColor = selectors.color('primary70');
  var hoverBackgroundColor = selectors.color('primary05');
  var borderColor = selectors.color(isDisabled ? 'neutral50' : 'primary70');
  var notDisabledStyles = isDisabled ? {} : {
    cursor: 'pointer',
    'input:focus + span': {
      color: hoverLabelColor
    },
    'input:focus ~ * > .toggle-button': {
      ':after': {
        backgroundColor: hoverBackgroundColor
      },
      ':before': {
        transform: "scale(".concat(_utils.BORDER_SCALE, ")"),
        borderColor: borderColor
      }
    },
    '&:hover': {
      color: hoverLabelColor,
      '.toggle-button': {
        ':after': {
          backgroundColor: hoverBackgroundColor
        }
      }
    },
    '&:active': {
      '.toggle-button': {
        ':after': {
          backgroundColor: hoverBackgroundColor
        },
        ':before': {
          transform: "scale(".concat(_utils.BORDER_SCALE, ")"),
          borderColor: borderColor
        }
      }
    }
  };
  return _objectSpread({
    display: 'flex',
    maxWidth: 'max-content',
    position: 'relative'
  }, notDisabledStyles);
});
Container.displayName = 'Container';
var _default = Container;
exports.default = _default;